import InfoModal from "../modals/InfoModal";

export default function StackedContent(props) {
  return (
    <div>
      <div className="text-4xl text-black font-bold leading-tight tracking-tight">
        {props.mainTitle}
      </div>
      {props.color ? (
        <div style = {{color: props.color}} className={`text-4xl mb-2 font-bold leading-tight tracking-tight`}>
          {props.colorTitle}
        </div>
      ) : (
        <div className="text-4xl mb-2 text-primary-200 font-bold leading-tight tracking-tight">
          {props.colorTitle}
        </div>
      )}

      {props.subText &&
        <h4 className="text-xl inline-flex items-center mb-8 text-black font-light leading-tight tracking-tight">
          <span className="mr-1">{props.subText}</span>
          <InfoModal title={props.modalTitle} desc={props.modalDesc}></InfoModal>
        </h4>
      }

    </div>
  )
}